var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6564 18.3054C22.2486 10.5163 29.1877 4.65455 37.5 4.65455C45.8123 4.65455 52.7512 10.5163 54.3436 18.3054C54.5653 19.3901 55.5258 20.1697 56.6405 20.1697H57.0312C64.3662 20.1697 70.3125 26.0741 70.3125 33.3575C70.3125 40.6409 64.3662 46.5455 57.0312 46.5455H47.2657C45.9713 46.5455 44.922 47.5874 44.922 48.8727C44.922 50.1581 45.9713 51.2 47.2657 51.2H57.0312C66.9551 51.2 75 43.2116 75 33.3575C75 23.9898 67.7295 16.3079 58.4857 15.5728C55.8145 6.57101 47.4323 0 37.5 0C27.5677 0 19.1855 6.57101 16.5143 15.5728C7.27062 16.3079 0 23.9898 0 33.3575C0 43.2116 8.04487 51.2 17.9688 51.2H27.7343C29.0287 51.2 30.078 50.1581 30.078 48.8727C30.078 47.5874 29.0287 46.5455 27.7343 46.5455H17.9688C10.6337 46.5455 4.6875 40.6409 4.6875 33.3575C4.6875 26.0741 10.6337 20.1697 17.9688 20.1697H18.3594C19.4741 20.1697 20.4346 19.3901 20.6564 18.3054Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8746 38.2725C47.7898 39.1813 47.7898 40.655 46.8746 41.5638C45.9594 42.4726 44.4753 42.4726 43.5601 41.5638L40.1033 38.1313V50.6148C40.1033 51.9001 39.054 52.942 37.7595 52.942C36.4651 52.942 35.4158 51.9001 35.4158 50.6148V38.1313L31.959 41.5638C31.0437 42.4726 29.5597 42.4726 28.6444 41.5638C27.7292 40.655 27.7292 39.1813 28.6444 38.2725L36.1022 30.8671C37.0175 29.9583 38.5015 29.9583 39.4168 30.8671L46.8746 38.2725Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9646e9543b5e89b98314284d75d942ec.svg";
export { ForwardRef as ReactComponent };